import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Title from "../../components/Title";
import { People } from "@material-ui/icons";
import FamilyMemberService from "../../services/FamilyMemberService";
import { DataGrid } from '@material-ui/data-grid';
import Spacer from "../../components/Spacer";
import LoadingSimpleBackdrop from "../tools/LoadingSimpleBackdrop";
import { useNavigate } from 'react-router-dom';
import Grid from "@material-ui/core/Grid";
import { hasPrivilege } from "../../utils/privilege";
import SearchIcon from '@mui/icons-material/Search';
import { userDetailContext } from "../../App";
import { useContext } from "react";
import {
  FormControl,
  Select,
  MenuItem,
  InputLabel
} from "@material-ui/core";
import TableViewIcon from '@mui/icons-material/TableView';
import PlanningService from "../../services/PlanningService";
import DirectionService from "../../services/DirectionService";
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import PersonInfoService from "../../services/PersonInfoService";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import * as XLSX from "xlsx";
import ExcelJS from 'exceljs';
import { saveAs } from "file-saver";

const useStyles = makeStyles((theme) => ({
  seeMore: {
    marginTop: theme.spacing(3),
  },
  root: {
    '& .personal-style': {
      backgroundColor: '#E8E8E8',
    },
  },
}));

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export default function FamilyMemberTable() {
  const navigate = useNavigate();
  const classes = useStyles();
  const contextData = useContext(userDetailContext);
  const [pageSize, setPageSize] = React.useState(10);
  const [opendialogue, setOpenDialogue] = useState(false);
  const [rows, setRows] = useState([]);
  const [direction, setDirection] = useState([]);
  const [service, setService] = useState([]);
  const [iddir, setIddir] = useState(0);
  const [form, setForm] = useState({
    direction_id: localStorage.getItem("USER_DIR"),
    service_id: 0
  });
  const [filters, setFilters] = useState({
    direction_id: localStorage.getItem("USER_DIR"),
    service_id: 0
  });
  const [valeur, setValeur] = useState({});
  const [idservice, setIdservice] = useState(0);
  const iddiruser = localStorage.getItem("USER_DIR");
  const [dataexport, setDataexport] = useState([]);
  const [details, setDetails] = useState({});
  const [famille, setFamille] = useState([]);

  function handleChangeDirection(event) {
    const { name, value } = event.target;
    setForm({ ...form, [name]: value });
    setIddir(value);
  }

  const handlePageSizeChange = (newPageSize) => {
    setPageSize(newPageSize);
  };

  const handleSubmit = () => {
    setFilters({
      direction_id: form.direction_id,
      service_id: form.service_id
    });
  };

  function handleChangeService(ev) {
    const { name, value } = ev.target;
    setForm({ ...form, [name]: value });
    setIdservice(value);
  }

  function handleClick() {
    navigate("/users/add");
  }

  const handleClickOpen = () => {
    setOpenDialogue(true);
  };

  const handleClose = () => {
    setOpenDialogue(false);
  };

  // Samuela: paramètrage pour le loader
  const [openLoadingSimpleBackdrop, setOpenLoadingSimpleBackdrop] = React.useState(false);

  useEffect(() => {
    setIddir(localStorage.getItem("USER_DIR"));
    DirectionService.getDirection().then((res) => {
      if (res && res.status) {
        setDirection(res.data);
      }
    });
  }, []);

  useEffect(() => {
    if (iddir !== 0 && iddir !== "") {
      PlanningService.Direction(iddir).then((results) => {
        if (results && results.data) {
          setService(results.data);
        }
      })
    }
  }, [iddir]);

  useEffect(() => {
    setOpenLoadingSimpleBackdrop(true);
    FamilyMemberService.getPersonalFamily(filters.direction_id, filters.service_id).then((result) => {
      if (result && result.data) {
        setRows(result.data.map((row) => ({ ...row, id: row.user_id })));
        setOpenLoadingSimpleBackdrop(false);
      } else {
        setOpenLoadingSimpleBackdrop(false);
      }
    });
    FamilyMemberService.getdataexport(filters.direction_id, filters.service_id).then((result) => {
      if (result && result.data) {
        setDataexport(result.data.map((row) => ({ ...row, id: row.user_id })));
      } else {
        setDataexport([]);
      }
    });
  }, [filters]);

  const handleEdit = (id) => (ev) => {
    setDetails(id);
    setOpenDialogue(true);
    setValeur({});
    PersonInfoService.famillydetail(id.user_id).then((res) => {
      if (res && res.status) {
        setValeur(res.data[0]);
        setFamille(res.famille);
      }
    });
  };

  const handleRowClick = (params) => {
    setDetails(params.row);
    setOpenDialogue(true);
    setValeur({});
    PersonInfoService.famillydetail(params.row.user_id).then((res) => {
      if (res && res.status) {
        setValeur(res.data[0]);
        setFamille(res.famille);
      }
    });
  };

  async function handleExportExcel() {
    try {
      // Définition des en-têtes de colonnes avec les dates de naissance des contacts d'urgence
      const columnsHeader = [
        { header: 'Direction', key: 'direction_code', width: 15 },
        { header: 'Service', key: 'service_code', width: 15 },
        { header: 'Matricule', key: 'registration_number', width: 15 },
        { header: 'Nom et prénom(s) du personnel', key: 'nom', width: 30 },
        { header: 'Fonction', key: 'function_code', width: 25 },
        { header: 'Date de naissance du personnel', key: 'birth_date', width: 25 },
        { header: "Nom et prénom(s) (Contact d'urgence 1)", key: 'emergency_name', width: 35 },
        { header: "Téléphone (Contact d'urgence 1)", key: 'emergency_phone', width: 35 },
        { header: "Date de naissance (Contact d'urgence 1)", key: 'emergency_birth_date', width: 25 },
        { header: "Nom et prénom(s) (Contact d'urgence 2)", key: 'emergency_name1', width: 35 },
        { header: "Téléphone (Contact d'urgence 2)", key: 'emergency_phone1', width: 35 },
        { header: "Date de naissance (Contact d'urgence 2)", key: 'emergency_birth_date1', width: 25 },
        { header: "Nom et prénom(s) (Contact d'urgence 3)", key: 'emergency_name2', width: 35 },
        { header: "Téléphone (Contact d'urgence 3)", key: 'emergency_phone2', width: 35 },
        { header: "Date de naissance (Contact d'urgence 3)", key: 'emergency_birth_date2', width: 25 },
      ];

      // Créer un nouveau workbook
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Contacts Urgence');

      // Ajouter les en-têtes de colonnes
      worksheet.columns = columnsHeader.map(col => ({
        header: col.header,
        key: col.key,
        width: col.width
      }));

      // Style pour l'en-tête (bleu)
      worksheet.getRow(1).font = {
        bold: true,
        color: { argb: 'FFFFFFFF' }
      };
      
      worksheet.getRow(1).fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FF4472C4' }
      };

      worksheet.getRow(1).alignment = {
        vertical: 'middle',
        horizontal: 'center'
      };

      // Appliquer des bordures à l'en-tête
      worksheet.getRow(1).border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' }
      };

      // Centrer chaque cellule de l'en-tête individuellement
      columnsHeader.forEach((_, index) => {
        const cell = worksheet.getCell(1, index + 1);
        cell.alignment = {
          vertical: 'middle',
          horizontal: 'center'
        };
      });

      // Ajouter les données - Sans formatage des dates, on garde les valeurs brutes
      dataexport.forEach(item => {
        // On garde les dates telles quelles, sans transformation
        const rowData = {
          ...item,
          birth_date: item.birth_date || '',
          emergency_birth_date: item.emergency_birth_date || '',
          emergency_birth_date1: item.emergency_birth_date1 || '',
          emergency_birth_date2: item.emergency_birth_date2 || '',
        };
        
        const row = worksheet.addRow(rowData);
        
        // Appliquer des bordures à chaque ligne de données
        row.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };

        // Centrer les colonnes spécifiques
        [1, 2, 3, 5, 6, 8, 9, 11, 12, 14, 15].forEach(colIndex => {
          const cell = row.getCell(colIndex);
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'center'
          };
        });
      });

      // Ajuster la hauteur de la ligne d'en-tête
      worksheet.getRow(1).height = 25;

      // Générer le fichier Excel
      const buffer = await workbook.xlsx.writeBuffer();

      // Télécharger le fichier
      const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });

      const fileName = "contacts_urgence.xlsx";
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);

    } catch (error) {
      console.error('Erreur lors de l\'export Excel:', error);
    }
  }

  const columns = [
    { field: 'user_name', headerName: 'Nom et Prénom(s) du Personnel', width: 330, cellClassName: 'personal-style' },
    { field: 'joint', headerName: 'Nom et Prénom(s) Conjoint', width: 330 },
    { field: 'child', headerName: 'Nom et Prénom(s) des enfants', width: 330 },
    {
      field: 'action',
      headerName: 'Action',
      disableClickEventBubbling: true,
      renderCell: (params) => {
        return (
          <>
            <Button onClick={handleEdit(params.row)}><People style={{ color: "black" }} /></Button>
          </>
        );
      },
      width: 140,
    },
  ];

  return (
    <React.Fragment>
      <LoadingSimpleBackdrop openLoadingSimpleBackdrop={openLoadingSimpleBackdrop} />
      <Grid container item xs={12}>
        <Grid item xs={3}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            startIcon={<SearchIcon />}
            style={{ fontWeight: 800, width: 170 }}
          >
            Filtrer
          </Button>
        </Grid>
        <Grid item xs={3}>
          <Button
            variant="contained"
            color="#9E9E9E"
            onClick={handleExportExcel}
            style={{ fontWeight: 600, width: "100%", display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          >
            <TableViewIcon style={{ marginRight: '8px' }} />
            Export excel
          </Button>
        </Grid>
      </Grid>
      <Spacer y={8} />
      <Grid container spacing={3} justifyContent="center">
        <Grid item xs={12} md={5} sm={6} lg={5}>
          <FormControl fullWidth variant="outlined" size="small">
            <InputLabel id="demo-simple-select-outlined-label">Direction</InputLabel>
            <Select
              labelId="demo-simple-select-outlined-label"
              id="demo-simple-select-outlined"
              label="Direction"
              value={form.direction_id}
              name="direction_id"
              onChange={handleChangeDirection}
              disabled={parseInt(iddiruser, 10) !== 1}
            >
              <MenuItem value={0}>Toutes</MenuItem>
              {direction.map((row) => (
                <MenuItem key={row.direction_id} value={row.direction_id}>
                  {row.code}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} md={5} sm={6} lg={5}>
          <FormControl fullWidth variant="outlined" size="small">
            <InputLabel id="demo-simple-select-outlined-label">Service</InputLabel>
            <Select
              labelId="demo-simple-select-outlined-label"
              id="demo-simple-select-outlined"
              label="Service"
              value={form.service_id}
              name="service_id"
              onChange={handleChangeService}
            >
              <MenuItem value={0}>Tous</MenuItem>
              {service.map((row) => (
                <MenuItem key={row.service_id} value={row.service_id}>{row.code}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
      <Title>Détails Personnels</Title>
      <Spacer y={2} />
      <div style={{ height: "70vh", width: '100%' }} className={classes.root}>
        <DataGrid
          rows={rows}
          columns={columns}
          disableSelectionOnClick
          pageSize={pageSize}
          pageSizeOptions={[10, 25, 50, 100]}
          onPageSizeChange={handlePageSizeChange}
          onRowClick={handleRowClick}
        />
      </div>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={opendialogue}
        sx={{ '& .MuiDialog-paper': { width: '80%', maxWidth: 'lg' } }}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          Détails Personnels - {details.user_name}
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={(theme) => ({
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <Grid container spacing={3} item xs={12}>
            <Grid item xs={4}>Nom et prénom(s) :</Grid>
            <Grid item xs={8}>{valeur.last_name + " " + valeur.first_name}</Grid>
            <Grid item xs={4}>Date de naissance :</Grid>
            <Grid item xs={8}>{new Date(valeur.birth_date).toLocaleDateString('fr-FR')} à {valeur.birth_place}</Grid>
            <Grid item xs={4}>Téléphone :</Grid>
            <Grid item xs={8}>{valeur.telephone}</Grid>
            <Grid item xs={4}>Adresse :</Grid>
            <Grid item xs={8}>{valeur.address}</Grid>
            <Grid item xs={4}>CIN :</Grid>
            <Grid item xs={8}>{valeur.card_number}</Grid>
            <Grid item xs={4}>Fait à :</Grid>
            <Grid item xs={8}>{valeur.card_deliverance_place}</Grid>
            <Grid item xs={4}>Le :</Grid>
            <Grid item xs={8}>{new Date(valeur.card_deliverance_date).toLocaleDateString('fr-FR')}</Grid>
            <Grid item xs={4}>Marital status :</Grid>
            <Grid item xs={8}>{valeur.marital_status}</Grid>
            <Grid item xs={4}>Nombre d'enfant :</Grid>
            <Grid item xs={8}>{valeur.number_child}</Grid>
            <Grid item xs={12}>Contact en cas d'urgence</Grid>
            <Grid item xs={12}>
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell align="center">Nom et prénom(s)</TableCell>
                      <TableCell align="center">Téléphone</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                      <TableCell align="center">{valeur.emergency_name}</TableCell>
                      <TableCell align="center">{valeur.emergency_phone}</TableCell>
                    </TableRow>
                    {valeur.emergency_name1 && valeur.emergency_phone1 && parseInt(valeur.emergency_name1, 10) !== 0 && valeur.emergency_name1 !== "" && (
                      <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                        <TableCell align="center">{valeur.emergency_name1}</TableCell>
                        <TableCell align="center">{valeur.emergency_phone1}</TableCell>
                      </TableRow>
                    )}
                    {valeur.emergency_name2 && valeur.emergency_phone2 && parseInt(valeur.emergency_name2, 10) !== 0 && valeur.emergency_name2 !== "" && (
                      <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                        <TableCell align="center">{valeur.emergency_name2}</TableCell>
                        <TableCell align="center">{valeur.emergency_phone2}</TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
            {valeur.marital_status === "marie" &&
              <Grid item xs={12}>
                <TableContainer component={Paper}>
                  <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        <TableCell align="center" sx={{ borderRight: '3px solid' }}></TableCell>
                        {famille.map((row, index) => (
                          <TableCell key={index} align="center" sx={{ borderRight: '3px solid' }}>
                            {row.relationship_name}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                        <TableCell align="center" sx={{ borderRight: '1px solid' }}>Nom et prénom(s) :</TableCell>
                        {famille.map((row, index) => (
                          <TableCell key={index} align="center" sx={{ borderRight: '1px solid' }}>
                            {row.person_name}
                          </TableCell>
                        ))}
                      </TableRow>
                      <TableRow sx={{ '&:last-child td, &:last-child th': { border: 1 } }}>
                        <TableCell align="center" sx={{ borderRight: '1px solid' }}>Date de naissance :</TableCell>
                        {famille.map((row, index) => (
                          <TableCell key={index} align="center" sx={{ borderRight: '1px solid' }}>
                            {new Date(row.details.birth_date).toLocaleDateString('fr-FR')} à {row.details.birth_place}
                          </TableCell>
                        ))}
                      </TableRow>
                      <TableRow sx={{ '&:last-child td, &:last-child th': { border: 1 } }}>
                        <TableCell align="center" sx={{ borderRight: '1px solid' }}>Adresse :</TableCell>
                        {famille.map((row, index) => (
                          <TableCell key={index} align="center" sx={{ borderRight: '1px solid' }}>
                            {row.details.address}
                          </TableCell>
                        ))}
                      </TableRow>
                      <TableRow sx={{ '&:last-child td, &:last-child th': { border: 1 } }}>
                        <TableCell align="center" sx={{ borderRight: '1px solid' }}>Téléphone :</TableCell>
                        {famille.map((row, index) => (
                          <TableCell key={index} align="center" sx={{ borderRight: '1px solid' }}>
                            {row.details.telephone}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            }
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose}>
            OK
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </React.Fragment>
  );
}